import { Component, OnDestroy, OnInit } from '@angular/core';
import { VpoName} from '../../../models/vpo.model';
import { RestService } from '../../../service/rest.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
import { getData, getSelected } from '../../../store/reducers/vpo';
import * as vpoActions from '../../../store/actions/vpo';
import * as structureActions from '../../../store/actions/structure';


@Component({
  selector: 'app-site-vp-selector',
  templateUrl: './site-vp-selector.component.html',
  styleUrls: ['./site-vp-selector.component.scss']
})
export class SiteVpSelectorComponent implements OnInit, OnDestroy {

  // vpo names
  vpoNames: Array<VpoName> = [];
  selectedVpo: VpoName;
  private subscribers: Array<any> = [];

  constructor(private restService: RestService,
              private route: Router,
              private store: Store<fromRoot.AppState>,
              private modalService: NgbModal) {
    // load vpo
    this.store.dispatch(new vpoActions.LoadAll());
    // load structures
    this.store.dispatch(new structureActions.LoadAll());
  }

  ngOnInit() {
    this.subscribers.push(this.store
      .pipe(
        select(fromRoot.selectVpoState())
      )
      .subscribe((state: any) => {
        this.vpoNames = getData(state);
      }));

    // get selected
    this.subscribers.push(this.store
      .pipe(
        select(fromRoot.selectVpoState())
      )
      .subscribe((state: any) => {
        this.selectedVpo = getSelected(state);
      }));
  }

  ngOnDestroy() {
    this.subscribers.forEach(s => s.unsubscribe());
  }

  openSelectorDialog(content) {
    this.modalService.open(content).result
      .then((result) => { }, (reason) => { });
  }

  selectVpo(v: VpoName) {
    this.store.dispatch(new vpoActions.UpdateData(v));
    // redirect
    this.route.navigate(['/' + v.code]);
  }

}
